import Text from 'components/elements/text';
import { FullContainer, SeparatorVertical } from 'components/styles';
import { CardSection } from 'legacy-modules/styles';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { TourAddOnsTable } from './addons-table';
import TourGuestCard from './tour-participant-table';
import TourParticipantDetailTable from './tour-partipant-detail-table';
import { TourSaleItemGuestFormType } from '../form-type';

interface Props {
  parentName: string;
}

export default function TourParticipantCard(props: Props) {
  const guestName = 'tourSales.0.tourSaleGuests' as const;
  const { control } = useFormContext();
  const tourGuests: TourSaleItemGuestFormType[] = useWatch({
    control,
    name: guestName,
  });

  return (
    <CardSection
      $style={{
        width: '100%',
      }}
    >
      <FullContainer>
        <TourGuestCard />
        <SeparatorVertical $margin={32} />
        {tourGuests?.map((item, idx) => {
          return (
            <React.Fragment key={item.customId}>
              <Text variant="LabelMedium">{item.guestName}</Text>
              <SeparatorVertical $margin={16} />
              <TourParticipantDetailTable parentIndex={idx} />
            </React.Fragment>
          );
        })}
      </FullContainer>
      <TourAddOnsTable parentIndex={0} />
    </CardSection>
  );
}
